// ** React Imports

// ** Custom Components

// ** Third Party Components
import PerfectScrollbar from 'react-perfect-scrollbar'

// ** Reactstrap Imports
import {
  mdiAccountSupervisorOutline,
  mdiArrangeSendToBack,
  mdiArrowCollapseAll,
  mdiClockOutline,
  mdiCloudSync,
  mdiCloudUpload,
  mdiCogTransferOutline,
} from '@mdi/js'
import Icon from '@mdi/react'
import { useNavigate } from 'react-router-dom'
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from 'reactstrap'
import NavRoutes from '../../../../common/NavRoutes'

const JunctionControlDropdown = () => {
  const navigate = useNavigate()

  const junctionControls = [
    {
      title: 'Junction Setting',
      icon: <Icon path={mdiCogTransferOutline} size={1} />,
      link: NavRoutes.junctionSetting,
      display: true,
    },
    {
      title: 'Sync Setting',
      icon: <Icon path={mdiCloudSync} size={1} />,
      link: NavRoutes.syncFromJunction,
      display: true,
    },
    {
      title: 'Update Setting',
      icon: <Icon path={mdiCloudUpload} size={1} />,
      link: NavRoutes.updateToJunction,
      display: true,
    },
    {
      title: 'Junction Clock',
      icon: <Icon path={mdiClockOutline} size={1} />,
      link: NavRoutes.clockSetting,
      display: true,
    },
    {
      title: 'XAITS Link Binding',
      icon: <Icon path={mdiArrangeSendToBack} size={1} />,
      link: NavRoutes.xaitsLinkPair,
      display: true,
    },
    {
      title: 'Whatsapp Alert Group',
      icon: <Icon path={mdiAccountSupervisorOutline} size={1} />,
      link: NavRoutes.alertGroup,
      display: true,
    },
  ]

  const renderJunctionControl = () => {
    return (
      <PerfectScrollbar
        className='media-list scrollable-container p-1'
        options={{
          wheelPropagation: false,
        }}
      >
        <Row>
          {junctionControls.map((junctionControl, index) => {
            return (
              <Col md={6} key={index}>
                <a
                  className='d-flex flex-column align-items-center p-2'
                  onClick={() => {
                    navigate(junctionControl.link)
                  }}
                >
                  {junctionControl.icon}
                  <small>{junctionControl.title}</small>
                </a>
              </Col>
            )
          })}
        </Row>
      </PerfectScrollbar>
    )
  }

  return (
    <UncontrolledDropdown
      tag='li'
      className='dropdown-notification nav-item me-25'
    >
      <DropdownToggle
        tag='a'
        className='nav-link'
        href='/'
        onClick={(e) => e.preventDefault()}
      >
        <Icon path={mdiArrowCollapseAll} size={1} />
      </DropdownToggle>
      <DropdownMenu end tag='ul' className='dropdown-menu-media mt-0'>
        <li className='dropdown-menu-header'>
          <DropdownItem className='d-flex' tag='div' header>
            <h4 className='notification-title mb-0 me-auto'>
              Junction Control
            </h4>
          </DropdownItem>
        </li>
        {renderJunctionControl()}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default JunctionControlDropdown
